import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createProduct } from "../../services/api";
import ProductForm from "../../components/ProductForm/ProductForm";

export default function CreateProduct() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    imagen: null,
    precio: "",
    destacado: false,
    detalles: [{ label: "", value: "" }],
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, type } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: e.target.checked }));
    } else if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: e.target.files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: e.target.value }));
    }
  };

  const handleDetalleChange = (index, field, value) => {
    const nuevosDetalles = [...formData.detalles];
    nuevosDetalles[index][field] = value;
    setFormData({ ...formData, detalles: nuevosDetalles });
  };

  const agregarDetalle = () => {
    setFormData({
      ...formData,
      detalles: [...formData.detalles, { label: "", value: "" }],
    });
  };

  const eliminarDetalle = (indexAEliminar) => {
    const nuevosDetalles = formData.detalles.filter(
      (_, indiceActual) => indiceActual !== indexAEliminar
    );
    setFormData({ ...formData, detalles: nuevosDetalles });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) newErrors.nombre = "El nombre es obligatorio.";
    if (!formData.descripcion.trim())
      newErrors.descripcion = "La descripción es obligatoria.";
    if (!formData.precio || formData.precio <= 0)
      newErrors.precio = "El precio debe ser mayor a 0.";
    if (!formData.imagen) newErrors.imagen = "Debe seleccionar una imagen.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("nombre", formData.nombre);
      formDataToSend.append("descripcion", formData.descripcion);
      formDataToSend.append("precio", formData.precio);
      formDataToSend.append("destacado", formData.destacado);
      formDataToSend.append("stock", formData.stock || 0);
      formDataToSend.append("detalles", JSON.stringify(formData.detalles));
      if (formData.imagen) {
        formDataToSend.append("imagen", formData.imagen);
      }

      await createProduct(formDataToSend);

      setSuccessMessage("Producto creado con éxito");
      setTimeout(() => navigate("/productos"), 1000);
    } catch (error) {
      console.error(error);
      setErrors({ general: "Hubo un problema al crear el producto." });
    }
  };

  return (
    <ProductForm
      formTitle="Crear nuevo producto"
      formData={formData}
      handleChange={handleChange}
      handleDetalleChange={handleDetalleChange}
      agregarDetalle={agregarDetalle}
      eliminarDetalle={eliminarDetalle}
      imagenPreview={""}
      errors={errors}
      successMessage={successMessage}
      onSubmit={handleSubmit}
      submitLabel="Crear producto"
    />
  );
}
